export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS";
export const GET_NOTIFICATION_FAIL = "GET_NOTIFICATION_FAIL";

export const SEEN_NOTIFICATION_SUCCESS = "SEEN_NOTIFICATION_SUCCESS";
export const SEEN_NOTIFICATION_FAIL = "SEEN_NOTIFICATION_FAIL";
